import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@app/core';
import { AboutComponent } from './about/about.component';
import { FeaturesComponent } from './features/features.component';
import { TransactionLogsComponent } from './transaction-logs/transaction-logs.component';
import { OrganizationInvoicesComponent } from '../static/organization/invoices/OrganizationInvoices.component';
import { IpsosInvoiceImportComponent } from './ipsos-invoice-import/ipsos-invoice-import.component';
import { ModernDashboardComponent } from './design-test/modern-dashboard.component';

const routes: Routes = [
  { path: 'organization/api-accounts', loadChildren: () => import('./api-accounts/api-accounts.module').then(m => m.ApiAccountsModule), canActivate: [AuthGuardService] },
  {
    path: 'design-test',
    component: ModernDashboardComponent,
    data: { title: 'Design test' },
    canActivate: [AuthGuardService]
  },
  {
    path: 'organization/ipsos-import',
    component: IpsosInvoiceImportComponent,
    data: { title: 'IPSOS filimport' },
    canActivate: [AuthGuardService]
  },
    //{ path: 'about', component: AboutComponent, data: { title: 'About..' } },
    //{
    //  path: 'features',
    //  component: FeaturesComponent,
    //  data: { title: 'Features' }
    //}

  {
    path: 'organization/invoices',
    component: OrganizationInvoicesComponent,
    data: {
      title: 'Fakturor'
    },
    canActivate: [AuthGuardService] // Only logged in can access this route 
  },

  {
      path: 'transactions',
      component: TransactionLogsComponent,
      data: {
          title: 'Ekonomi'
      },
      canActivate: [AuthGuardService] // Only logged in can access this route 
  }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class StaticRoutingModule { }
